import { useEffect, useState } from 'react';

/**
 * Returns true briefly on mount to show a skeleton/loading state.
 * Useful for tab switches where data is already loaded but we want
 * a visual transition.
 */
export const useMountingSkeleton = (durationMs: number = 500): boolean => {
    const [mounting, setMounting] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => setMounting(false), durationMs);
        return (): void => clearTimeout(timer);
    }, [durationMs]);

    return mounting;
};
